import { getVideoInformationURI, getDownloadLinkURI, getHlsLinkURI, getAudioLinkURI } from "./configsURI";
import axios from "axios";

export const getVideoInformation = async (id) => {
  try {
    const result = await axios.get(`${getVideoInformationURI}?link=${id}`);
    return result.data || {};
  } catch (error) {
    return error?.response?.data || {};
  }
};
export const getDownloadLink = (link, videoID) => {
  return `${getDownloadLinkURI}?link=${link}&video_id=${videoID}`;
};
export const getHlsLink = (link) => {
  return `${getHlsLinkURI}?link=${link}`;
};
export const getAudioLink = (link) => {
  return `${getAudioLinkURI}?link=${link}`;
};
